import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
// import axios from 'axios';

// Add a request interceptor
// axios.interceptors.request.use(function (config) {
//   // Do something before request is sent
//   // console.log(config);

//   return config;
// }, function (error) {
//   console.log(error);
//   // Do something with request error
//   return Promise.reject(error);
// });

// // Add a response interceptor
// axios.interceptors.response.use(function (response) {
//   // Do something with response data
//   console.log(response);
//   return response;
// }, function (error) {
//   console.log(error);
//   // Do something with response error
//   return Promise.reject(error);
// });

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js